import { useEffect } from 'react';
import brandConfig from '../config/brandConfig';

export default function GoogleAnalytics() {
  useEffect(() => {
    const gaId = brandConfig.gaId;
    
    if (!gaId) {
      return;
    }

    // Cargar script de Google Analytics
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script1);

    // Inicializar gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId);

    return () => {
      // Cleanup si es necesario
      const scripts = document.querySelectorAll(`script[src*="googletagmanager"]`);
      scripts.forEach(script => script.remove());
    };
  }, []);

  return null;
}

